"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResource = void 0;

var _shared = require("@clayui/shared");

var _react = _interopRequireDefault(require("react"));

var _warning = _interopRequireDefault(require("warning"));

var _types = require("./types");

var _useCache = require("./useCache");

var _util = require("./util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useResource = function useResource(_ref) {
  var fetcher = _ref.fetch,
      _ref$fetchDelay = _ref.fetchDelay,
      fetchDelay = _ref$fetchDelay === void 0 ? 300 : _ref$fetchDelay,
      fetchOptions = _ref.fetchOptions,
      _ref$fetchPolicy = _ref.fetchPolicy,
      fetchPolicy = _ref$fetchPolicy === void 0 ? _types.FetchPolicy.NoCache : _ref$fetchPolicy,
      _ref$fetchTimeout = _ref.fetchTimeout,
      fetchTimeout = _ref$fetchTimeout === void 0 ? 6000 : _ref$fetchTimeout,
      link = _ref.link,
      _ref$onNetworkStatusC = _ref.onNetworkStatusChange,
      dispatchNetworkStatus = _ref$onNetworkStatusC === void 0 ? function () {} : _ref$onNetworkStatusC,
      _ref$pollInterval = _ref.pollInterval,
      pollInterval = _ref$pollInterval === void 0 ? 0 : _ref$pollInterval,
      _ref$storage = _ref.storage,
      storage = _ref$storage === void 0 ? _defineProperty({}, _types.SYMBOL_ORIGIN, true) : _ref$storage,
      _ref$fetchRetry = _ref.fetchRetry,
      fetchRetry = _ref$fetchRetry === void 0 ? {} : _ref$fetchRetry,
      _ref$storageMaxSize = _ref.storageMaxSize,
      storageMaxSize = _ref$storageMaxSize === void 0 ? 20 : _ref$storageMaxSize,
      _ref$variables = _ref.variables,
      variables = _ref$variables === void 0 ? null : _ref$variables;

  var _React$useState = _react.default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      resource = _React$useState2[0],
      setResource = _React$useState2[1];

  var pollingTimeoutId = _react.default.useRef(null).current;

  var retryDelayTimeoutId = _react.default.useRef(null).current;

  var pollIntervalRef = _react.default.useRef(pollInterval); // A flag to identify if the first rendering happened to avoid
  // two requests.


  var firstRenderRef = _react.default.useRef(true);

  var cache = (0, _useCache.useCache)(fetchPolicy, storage, storageMaxSize, link, variables);
  var debouncedVariablesChange = (0, _shared.useDebounce)(variables, fetchDelay);

  var handleRefetch = function handleRefetch() {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    doFetch();
    dispatchNetworkStatus(_types.NetworkStatus.Refetch);
  };

  var cleanRetry = function cleanRetry() {
    if (retryDelayTimeoutId) {
      clearTimeout(retryDelayTimeoutId);
    }
  };

  var getRetryDelay = function getRetryDelay(retryAttempts) {
    var _fetchRetry$delay = fetchRetry.delay,
        delay = _fetchRetry$delay === void 0 ? {} : _fetchRetry$delay;
    var _delay$initial = delay.initial,
        initial = _delay$initial === void 0 ? 300 : _delay$initial,
        _delay$jitter = delay.jitter,
        jitter = _delay$jitter === void 0 ? true : _delay$jitter;
    var baseDelay = jitter ? initial : initial / 2;
    var value = baseDelay * Math.pow(2, retryAttempts);

    if (jitter) {
      value = Math.random() * value;
    }

    return value;
  };

  var handleFetchRetry = function handleFetchRetry(error, retryAttempts) {
    var _fetchRetry$attempts = fetchRetry.attempts,
        attempts = _fetchRetry$attempts === void 0 ? 5 : _fetchRetry$attempts;
    cleanRetry();

    if (attempts > 0 && retryAttempts < attempts) {
      var delay = getRetryDelay(retryAttempts); // eslint-disable-next-line no-console

      console.warn("DataProvider: Trying ".concat(retryAttempts + 1, " of ").concat(attempts, " will happen in ").concat(delay, "ms"));
      retryDelayTimeoutId = setTimeout(function () {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        doFetch(retryAttempts + 1);
      }, delay);
    } else {
      dispatchNetworkStatus(_types.NetworkStatus.Error);
      "production" !== "production" ? (0, _warning.default)(false, "DataProvider: Error making the requisition ".concat(error)) : void 0;
    }
  };

  var cleanPoll = function cleanPoll() {
    return pollingTimeoutId && clearTimeout(pollingTimeoutId);
  };

  var setPoll = function setPoll() {
    cleanPoll();
    pollingTimeoutId = setTimeout(function () {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      maybeFetch(_types.NetworkStatus.Polling);
    }, pollIntervalRef.current);
  };

  var fetchOnComplete = function fetchOnComplete(result) {
    // Should clear retry interval if any of the
    // attempts are successful.
    cleanRetry();
    setResource(result);
    dispatchNetworkStatus(_types.NetworkStatus.Unused);
    cache.set(result);

    if (pollIntervalRef.current > 0) {
      setPoll();
    }
  };

  var populateSearchParams = function populateSearchParams(uri, variables) {
    if (!variables) {
      return uri;
    }

    var keys = Object.keys(variables);
    keys.forEach(function (key) {
      return uri.searchParams.set(key, variables[key]);
    });
    return uri;
  };

  var getUrlFormat = function getUrlFormat(link, variables) {
    var uri = new URL(link);
    "production" !== "production" ? (0, _warning.default)(uri.searchParams.toString() === '', 'DataProvider: We recommend that instead of passing parameters over the link, use the variables API. \n More details: https://clayui.com/docs/components/data-provider.html') : void 0;

    if (!variables) {
      return uri.toString();
    }

    populateSearchParams(uri, variables);
    return uri.toString();
  };

  var doFetch = function doFetch() {
    var retryAttempts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var promise;
    "production" !== "production" ? (0, _warning.default)(typeof link === 'string', 'DataProvider: The behavior of the `link` accepting a function has been deprecated in favor of the `fetcher` API. \n More details: https://clayui.com/docs/components/data-provider.html#data-fetching') : void 0;

    switch (_typeof(link)) {
      case 'function':
        promise = link(populateSearchParams( // This is just a hack to be able to instantiate the URL and make
        // `populateSearchParams` reusable in `getUrlFormat` and make
        // things easier.
        new URL('http://clay.data.provider'), variables).searchParams.toString());
        break;

      case 'string':
        {
          var fn = fetcher !== null && fetcher !== void 0 ? fetcher : fetch;
          promise = fn(getUrlFormat(link, variables), fetchOptions).then(function (res) {
            if (res.ok && !res.bodyUsed) {
              return res.json();
            }

            return res;
          });
          break;
        }

      default:
        return null;
    }

    (0, _util.timeout)(fetchTimeout, promise).then(fetchOnComplete).catch(function (error) {
      return handleFetchRetry(error, retryAttempts);
    });
  };

  var maybeFetch = function maybeFetch(status) {
    var cacheData = cache.get();

    if (cacheData) {
      fetchOnComplete(cacheData); // When fetch policy is only cache-first and gets the data from
      // the cache, it should not perform a request, only when it is
      // cache-and-network.

      if (fetchPolicy === _types.FetchPolicy.CacheFirst) {
        return false;
      }
    }

    dispatchNetworkStatus(status);
    doFetch();
  };

  _react.default.useEffect(function () {
    pollIntervalRef.current = pollInterval;

    if (pollInterval > 0) {
      setPoll();
    }
  }, [pollInterval]);

  _react.default.useEffect(function () {
    if (!firstRenderRef.current) {
      maybeFetch(_types.NetworkStatus.Refetch);
    }
  }, [debouncedVariablesChange]);

  _react.default.useEffect(function () {
    maybeFetch(_types.NetworkStatus.Loading);
    firstRenderRef.current = false;
    return function () {
      // Reset the cache only if the storage reference is
      // local from useResource.
      if (storage[_types.SYMBOL_ORIGIN]) {
        cache.reset();
      } // Set to zero to prevent any unfinished requests
      // from continuing polling after umount has occurred.


      pollIntervalRef.current = 0;
      cleanPoll();
      cleanRetry();
    };
  }, []);

  return {
    refetch: handleRefetch,
    resource: resource
  };
};

exports.useResource = useResource;